import {DriveEventDto} from "../drives/drive-events/DriveEventDto";

export class DriveScorecard {
  features: ScorecardMapFeaturesDto
  events: DriveEventDto[]
  details: DriveDetails
  tripScoreType: TripScoreType
}

export class DriveDetails {
  organizationName: string;
  terminalName: string;
  driverName: string;
  driverFirstName: string;
  driverLastName: string;
  startTimeUtc: Date;
  endTimeUtc: Date;
  simplifiedPolyLine: any;
  sessionKey: string;
  minLat: number;
  maxLat: number;
  minLon: number;
  maxLon: number;
  distance: number;
  distanceUnit: string;
}

export class ScorecardMapFeaturesDto {
  features: any
}

/**
 * Represents an enum of the different types of scores that can be calculated for a trip.
 * The values are used to map the score type to a string that can be displayed to the user.
 * The values must match the values in the backend class `TripScoreTypeEnum`.
 */
export enum TripScoreType {
  Average = "Average",
  ControlledSpeedLightFoot = "ControlledSpeedLightFoot",
  ControlledSpeedHeavyFoot = "ControlledSpeedHeavyFoot",
  TooFastLightFoot = "TooFastLightFoot",
  TooFastHeavyFoot = "TooFastHeavyFoot"
}

/**
 * Represents a model for the score type that can be sent from the backend.
 * Matches the model in the backend class `TripScoreTypeModel`.
 */
export class TripScoreTypeModelDto {
  tripScoreType: string
}
